export class ReactiverDossier
{
    requestId: String;
    motif: String;
}